if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });
    }

    initSlider(swiperOptions) {
      // Initialize Swiper for continuous scrolling effect
      this.slider = new Swiper(this, {
        slidesPerView: 'auto',  // Allows to show multiple slides at once
        spaceBetween: 0,        // No gap between slides
        loop: true,             // Loop the slides for continuous effect
        autoplay: {
          delay: 0,             // No delay between slides, so it's a continuous ticker
          disableOnInteraction: false,  // Keep autoplaying even when user interacts
        },
        speed: 0,               // No Swiper transition speed since we'll use CSS animation
        allowTouchMove: false,  // Disable touch movement to keep it smooth and continuous
        slidesPerGroup: 1,      // Slide one at a time for smooth scroll
      });

      // To add multiple copies of slides for seamless loop
      const swiperWrapper = this.querySelector('.swiper-wrapper');
      const slides = swiperWrapper.querySelectorAll('.swiper-slide');
      
      // Duplicate the slides dynamically to create an infinite loop effect
      slides.forEach(slide => {
        const clonedSlide = slide.cloneNode(true);  // Clone each slide
        swiperWrapper.appendChild(clonedSlide);     // Append the clone to the end
      });

      // Add a class to the swiper-wrapper for CSS animation
      swiperWrapper.classList.add('ticker-scrolling');
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
